/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../../node_modules/@types/jqueryui/index.d.ts" />
/// <reference path="../shared/jquery.extension.d.ts" />
/// <reference path="../shared/foundation.d.ts" />

import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { ElementRef, Injectable } from '@angular/core';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { AccessControlMenu } from '../models/access-control-menu.model';
import { UserAccessMenu } from '../models/user-access-menu.model';
import { AccessMenuViewModel } from '../models/AccessMenuViewModel';
import { ApiResponse } from '../models/api-response.model';
import { Validators } from '@angular/forms';
// import { ToastData, ToastOptions, ToastyService } from 'ng2-toasty';
import { IMenu } from '../models/imenu.model';
import { Router } from '@angular/router';
import { ToastComponent } from '../shared/toast/toast.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HardwareDeviceReportModel, HardwareReadinessModel, WindowsFeatureModel, WorkFromAnywhereModel } from '../models/Windows11Readiness.model';


@Injectable()
export class Windows11AssessmentService {
  analyticsImpression = 'I';
  analyticsClick = 'C';
  step = '';

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router
) {
}
  private dataSubject = new BehaviorSubject<any[]>([]);

  private windowsFeatureSubject = new BehaviorSubject<WindowsFeatureModel[] | null>(null);
  private workAnywhereSubject = new BehaviorSubject<WorkFromAnywhereModel[] | null>(null);
  private hardwareReadinessSubject = new BehaviorSubject<HardwareDeviceReportModel[] | null>(null);
  win11ModelType$ = new BehaviorSubject<'workFromAnywhere' | 'windowsFeature' | 'hardwareReadiness' | null>(null);
  private allDevicesUpgradedToWin11Subject = new BehaviorSubject<boolean>(false);
  allDevicesUpgradedToWin11$ = this.allDevicesUpgradedToWin11Subject.asObservable();

  windowsFeature$ = this.windowsFeatureSubject.asObservable();
  workAnywhere$ = this.workAnywhereSubject.asObservable();
  hardwareReadiness$ = this.hardwareReadinessSubject.asObservable();

  windows11OsVersion = '10.0.22000.194'; // Default version for Windows 11

  SetWindowsFeatureData(data: WindowsFeatureModel[]) {
    this.windowsFeatureSubject.next(data);
  }

  setWorkAnywhereData(data: WorkFromAnywhereModel[]) {
    this.workAnywhereSubject.next(data);
  }

  setHardwareReadinessData(data: HardwareDeviceReportModel[]) {
    this.hardwareReadinessSubject.next(data);
  }

  setWin11ModelType(type: 'workFromAnywhere' | 'windowsFeature' | 'hardwareReadiness' | null) {
    this.win11ModelType$.next(type);
  }

  setAllDevicesUpgradedToWin11(value: boolean): void {
    this.allDevicesUpgradedToWin11Subject.next(value);
  }

 isOSVersionGreater(osVersion: string): boolean {
    const osParts = osVersion.split('.').map(Number);
    const targetParts = this.windows11OsVersion.split('.').map(Number);
    for (let i = 0; i < Math.max(osParts.length, targetParts.length); i++) {
      const osPart = osParts[i] || 0; // Default to 0 if part is missing
      const targetPart = targetParts[i] || 0;
  
      if (osPart > targetPart) return true;
      if (osPart < targetPart) return false;
    }
  
    return false; // Versions are equal or less
  }

   extractNumericOSVersion(osVersion: string): string {
    // Use a regular expression to extract the numeric part of the version
    const match = osVersion.match(/(\d+\.\d+\.\d+(\.\d+)?)/);
    return match ? match[0] : '0.0.0.0'; // Default to '0.0.0.0' if no match is found
  }
}
